import { IonText } from "@ionic/react";
import type React from "react";
import ReactMarkdown from "react-markdown";
import { cx } from "@/lib/style/cva.config";

const MarkdownParagraph = ({ children, ...props }: React.ComponentPropsWithoutRef<"p">) => (
	<IonText data-mask-text className={cx("mb-4 block last:mb-0", props.className)}>
		{children}
	</IonText>
);

export function Markdown({
	children,
	...props
}: React.ComponentPropsWithoutRef<typeof ReactMarkdown> & { children: string }) {
	return (
		<ReactMarkdown
			data-mask-text
			{...props}
			components={{
				p: MarkdownParagraph,
				...props.components,
			}}
		>
			{children}
		</ReactMarkdown>
	);
}
